import type { CodeSystem, CodeSystemConcept } from '@medplum/fhirtypes';

const URL = 'https://liza.health/fhir/CodeSystem/survey-scores';

/** System for in-house survey total-score codes — the result code an instrument's Task/Goal/Observation
 * carry when no standard total-score LOINC exists (see the survey FHIR design-decision doc). */
export const SURVEY_SCORES_SYSTEM = URL;

const CONCEPTS = [
  { code: 'mood-scale', display: 'Mood' },
  { code: 'pgic', display: 'PGIC' },
] as const satisfies CodeSystemConcept[];

export type SurveyScoreCode = (typeof CONCEPTS)[number]['code'];

export const surveyScoresCodeSystem: CodeSystem = {
  resourceType: 'CodeSystem',
  url: URL,
  name: 'survey-scores',
  title: 'Survey Scores',
  identifier: [{ system: 'urn:ietf:rfc:3986', value: URL }],
  status: 'active',
  content: 'complete',
  concept: CONCEPTS,
};
